module.exports = __webpack_public_path__ + "static/portfolio-mas-7-a975fc8749282351dba321738e8e1ef5.jpg";